import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CtasIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Ctas",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m29.91 19.26-6.34-7.04a.515.515 0 0 0-.88.34v9.48c.04.24.25.42.5.42.04 0 .09 0 .13-.02s2.07-.79 2.07-.79l1.46 3.83c.08.19.26.32.48.32.06 0 .13-.01.18-.03s1.27-.48 1.27-.48c.19-.08.32-.26.32-.48 0-.06-.01-.13-.03-.18l-1.46-3.82 2.07-.79c.18-.08.31-.26.31-.47 0-.11-.03-.21-.09-.29Zm-8.97-6.72a2.26 2.26 0 0 1 2.26-2.21c.67 0 1.26.29 1.68.74s2.82 3.04 2.82 3.04v-4.7c0-1.77-1.44-3.21-3.21-3.21H5.21C3.44 6.2 2 7.64 2 9.41v5.27c0 1.77 1.44 3.2 3.21 3.2h15.71v-5.35Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25.86 10.14h-2.29a1.14 1.14 0 1 1 0-2.28h2.29c.63 0 1.14-.51 1.14-1.14V3.29c0-.63-.51-1.14-1.14-1.14H5.29c-.63 0-1.14.51-1.14 1.14v3.43c0 .63.51 1.14 1.14 1.14h4.57a1.14 1.14 0 1 1 0 2.28H5.29c-1.89 0-3.43-1.54-3.43-3.43V3.28C1.86 1.4 3.4-.14 5.29-.14h20.57c1.89 0 3.43 1.54 3.43 3.43v3.43c0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.43 21.57c-.63 0-1.14-.51-1.14-1.14V9c0-1.89 1.54-3.43 3.43-3.43S20.15 7.11 20.15 9v8a1.14 1.14 0 1 1-2.28 0V9a1.14 1.14 0 1 0-2.28 0v11.43c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.57 18.14c-.63 0-1.14-.51-1.14-1.14v-2.29a1.14 1.14 0 1 0-2.28 0V17a1.14 1.14 0 1 1-2.28 0v-2.29c0-1.89 1.54-3.43 3.43-3.43s3.43 1.54 3.43 3.43V17c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 20.43c-.63 0-1.14-.51-1.14-1.14V17a1.14 1.14 0 1 0-2.28 0v1.14a1.14 1.14 0 1 1-2.28 0V17c0-1.89 1.54-3.43 3.43-3.43S29.3 15.11 29.3 17v2.29c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.57 18.14c-.63 0-1.14-.51-1.14-1.14v-2.29a1.14 1.14 0 1 1 2.28 0V17c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.57 27.29h-9.14c-3.15 0-5.71-2.56-5.71-5.71v-3.43c0-1.89 1.54-3.43 3.43-3.43h2.29c.63 0 1.14.51 1.14 1.14v3.43a1.14 1.14 0 1 1-2.28 0V17h-1.14c-.63 0-1.14.51-1.14 1.14v3.43c0 1.89 1.54 3.43 3.43 3.43h9.14c1.89 0 3.43-1.54 3.43-3.43V17a1.14 1.14 0 1 1 2.28 0v4.57c0 3.15-2.56 5.71-5.71 5.71ZM27 31.86H11a1.14 1.14 0 1 1 0-2.28h16a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
CtasIcon.displayName = 'CtasIcon';